module.exports = __webpack_public_path__ + "assets/img/zh-Hant-a9b99174.png";